import { Injectable, OnInit } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class ToggleMenuService implements OnInit {
  private readonly showBehaviorSubject$ = new BehaviorSubject(false);
  showMobileMenu$ = this.showBehaviorSubject$.asObservable();
  NOT_DESKTOP = Number(window.innerWidth) <= 976;

  ngOnInit(): void {}

  toggle(): Observable<boolean> {
    let show: boolean;
    this.showMobileMenu$
      .pipe(
        tap(sub => {
          show = sub;
        })
      )
      .subscribe();
    this.showBehaviorSubject$.next(!show);
    return this.showMobileMenu$;
  }

  close(): Observable<boolean> {
    this.showBehaviorSubject$.next(false);
    return this.showMobileMenu$;
  }

  open(): Observable<boolean> {
    this.showBehaviorSubject$.next(true);
    return this.showMobileMenu$;
  }

  autoToggleMenu() {
    if (this.NOT_DESKTOP) {
      return this.close().pipe(tap(x => true));
    } else {
      return this.open().pipe(tap(x => false));
    }
  }
}
